export type MaskConfiguration = Partial<IMask.AnyMaskedOptions> & {
  unmask?: "typed" | boolean;
};

export const MASK_THOUSANDS_SEPARATOR: MaskConfiguration = {
  unmask: true,
  mask: Number,
  scale: 4,
  thousandsSeparator: " ",
};

export const MASK_NUMBER: MaskConfiguration = {
  unmask: true,
  mask: Number,
  scale: 4,
  thousandsSeparator: "",
};
